export default "__VITE_ASSET__DFI1TmQs__"